import React, { useContext, useState } from "react";
import { Modal, Form, Input, Divider, Typography, message } from "antd";
import { UserDataContext } from "../../context/User";
// import { useNavigate } from "react-router-dom";

const { Link } = Typography;

const AuthModal = ({ open, setOpen }) => {
  // const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const { login, setUserData } = useContext(UserDataContext);

  const handleLogin = async (values) => {
    setLoading(true);
    try {
      const response = await login({
        emailOrMemberId: values.emailOrMemberId,
        password: values.password,
        from: "web",
      });

      if (response?.success) {
        messageApi.success("Login successful!");
        setUserData(response.user || null);
        form.resetFields();
        setOpen(false);
        // navigate("/designer");
      } else {
        messageApi.error(response?.message || "Login failed");
      }
    } catch (err) {
      messageApi.error(
        err.response?.data?.message || err.message || "Login failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {contextHolder}

      {/* Login Modal */}
      <Modal
        title={
          <span className="text-xl font-semibold text-[#1ab7ea]">
            Sign In to Your Account
          </span>
        }
        open={open}
        onCancel={() => setOpen(false)}
        onOk={() =>
          form
            .validateFields()
            .then((values) => handleLogin(values))
            .catch(() => {})
        }
        okText="Sign In"
        confirmLoading={loading}
        cancelText="Cancel"
        centered
        className="custom-auth-modal"
      >
        <Divider className="mb-4 border-[#1ab7ea]/40" />

        <Form form={form} layout="vertical" className="space-y-2">
          <Form.Item
            label="Email or Member ID"
            name="emailOrMemberId"
            rules={[
              { required: true, message: "Enter your email or member ID" },
            ]}
          >
            <Input
              placeholder="Enter your email or member ID"
              className="rounded-lg focus:border-[#1ab7ea] focus:shadow-md transition-all"
            />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Enter your password" }]}
          >
            <Input.Password
              placeholder="••••••••"
              className="rounded-lg focus:border-[#1ab7ea] focus:shadow-md transition-all"
            />
          </Form.Item>

          <div className="flex justify-end items-center mt-2">
            <Link className="text-[#1ab7ea] hover:text-[#1877F2] font-medium">
              Forgot Password?
            </Link>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default AuthModal;
